import axios from 'axios';
import { setToken, onBoardingDigital, setUsuario , setIdClientAnalytics } from '../../../actions/actions';
import { store } from '../../../store/configure';

export const storeToken = (token) => {
    store.dispatch(
        setToken(token),
        onBoardingDigital(0)
    );
}

export const processToken = (history) => {
    var state = store.getState();
    return new Promise((resolve, reject) => {
        validateToken(state.token.id).then((response) => {
            if (response && response.data && response.data.standalone){
                sessionStorage.setItem('tipoFlujo', 'standalone')
            }
            else{
                sessionStorage.setItem('tipoFlujo','comun')
            }
            store.dispatch(
                setToken(state.token.id, response.data.valido)
            );
            store.dispatch(
                setUsuario(response.data.nombre, response.data.correo)
            );
            store.dispatch(
                setIdClientAnalytics(response.data.idClientAnalytics)
            );
            resolve(response.data.urlIndex);
        }).catch((error) => {
            if (!state.token.id) {
                store.dispatch(
                    setToken('', false),
                    onBoardingDigital(0)
                );   
            } else {
                store.dispatch(
                    onBoardingDigital(0)
                );
            }
            
            if (history!=null) {
                history.push('/error-resolucion');
                reject({
                    message: error.message
                })
            }
        });
    })
}

const validateToken = (token) => {
    return new Promise((resolve, reject) => {
        axios.get(localStorage.getItem('url') + '/api/vu/checkToken', {
            params: {
                id: token
            }
        }).then((response) => {
            if (response.status === 200) {
                resolve({
                    message: 'Token valido.',
                    data: response.data
                })
            } else {
                reject({
                    message: 'Token invalido.',
                })
            }
        }).catch(() => {
            reject({
                message: 'Ocurrio un error al validar el token.'
            });
        });
    })
}


// WEBPACK FOOTER //
// ./src/components/OnBoarding/services/tokenService.js